module.exports = __webpack_public_path__ + "img/qr1.3548bdc2.png";